import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';
import AssignmentIndRoundedIcon from '@mui/icons-material/AssignmentIndRounded';
import { ApprovalFieldDef } from '../types';

export const DECISIONS = {
  AWAITING_REVIEW: 'Awaiting Review',
  REQUESTED_ADDITIONAL_INFO: 'Requested Additional Information',
  DECLINED: 'Declined',
  PRE_APPROVED: 'Pre-Approved',
  APPROVED: 'Approved',
} as const;

export type Decision = (typeof DECISIONS)[keyof typeof DECISIONS];

export const APPROVAL_DETAILS_DECISION_STEPS = [
  { label: 'Awaiting Review', Icon: AssignmentIndRoundedIcon },
  { label: 'Requested Additional Information', Icon: InfoOutlinedIcon },
  { label: 'Approved', Icon: ThumbUpAltRoundedIcon },
];

export const APPROVAL_FIELDS: ApprovalFieldDef[] = [
  { key: 'lenderName', label: 'Lender Name', type: 'text' },
  { key: 'decision', label: 'Decision', type: 'text' },
  { key: 'applicantName', label: 'Applicant Name', type: 'text' },
  { key: 'approvalAmount', label: 'Approved Amount', type: 'currency' },
  { key: 'termLengthMonths', label: 'Term (Months)', type: 'number' },
  { key: 'monthlyPayment', label: 'Monthly Payment', type: 'currency' },
  { key: 'interestRate', label: 'Interest Rate', type: 'percentage' },
  { key: 'downPaymentToVendor', label: 'Down Payment', type: 'currency' },
  { key: 'docFees', label: 'Doc Fees', type: 'currency' },
  { key: 'minimumRequiredDownPayment', label: 'Minimum down payment (%)', type: 'percentage' },
  { key: 'daysToFirstPayment', label: 'Days To First Payment', type: 'text' },
];
